import backendStringConstants from '../../libs/backendStringConstants'

const clientIdRegEx = /.{1,}/
const siteIdRegEx = /.{1,}/

const testLists = new RegExp(
  `/tests-lists/summary/${clientIdRegEx.source}/${siteIdRegEx.source}`
)
const editClient = new RegExp(
  `/edit-client/${clientIdRegEx.source}/${siteIdRegEx.source}`
)
const uploads = new RegExp(
  `/uploads/${clientIdRegEx.source}/${siteIdRegEx.source}`
)
const dicomUploads = new RegExp(
  `/dicom/uploads/${clientIdRegEx.source}/${siteIdRegEx.source}`
)
const radiologistLists = new RegExp(
  `/radiologist-lists/summary/${clientIdRegEx.source}/${siteIdRegEx.source}`
)
const clientSummary = new RegExp(
  `/client-lists/summary/${clientIdRegEx.source}/${siteIdRegEx.source}`
)
const viewer = new RegExp(
  `/viewer/${clientIdRegEx.source}/${siteIdRegEx.source}`
)

const RolesAccessMatrix = {
  [backendStringConstants.HEALTHWORKER]: {
    routes: [
      '/add-client',
      '/tests-lists',
      '/uploads',
      '/edit-client',
      '/dicom/uploads'
    ],
    parameterisedRoutes: [testLists, editClient, uploads, dicomUploads]
  },
  [backendStringConstants.RADIOLOGIST]: {
    routes: ['/radiologist-lists'],
    parameterisedRoutes: [radiologistLists]
  },
  [backendStringConstants.ADMIN]: {
    routes: [
      '/add-client',
      '/manage-users',
      '/manage-sites',
      '/uploads',
      '/radiologist-lists',
      '/tests-lists',
      '/dicom/uploads'
    ],
    parameterisedRoutes: [testLists, uploads, radiologistLists, editClient]
  },
  common: {
    routes: ['/', '/client-lists', '/scp'],
    parameterisedRoutes: [clientSummary, viewer]
  }
}

export default RolesAccessMatrix
